<template>
  <small>{{ this.discount }}% DE DESCUENTO</small>
</template>

<script>
export default {
  props: {
    discount: { type: Number, default: 0 },
  },
};
</script>
